import { useSizeGuide } from "./use-size-guide";
import { SizeGuideTableWrapper } from "./size-guide-table-wrapper";
import { SizeGuideFooter } from "./size-guide-footer";
import { MeasuringInstructions } from "./measuring-instructions";
import { useTranslate } from "@made-people/grease-translations";
import { ButtonAsButton } from "@made-people/blueprint-button";
import { useCountriesAndLanguages } from "@made-people/grease-countries-and-languages";
import { useState } from "react";

export const BraCharts = () => {
  const sizeGuide = useSizeGuide();
  const translate = useTranslate();
  const { currentCountryCode, currentLanguageCode } =
    useCountriesAndLanguages();
  const [showState, setShowState] = useState<"calculator" | "table" | null>(
    null,
  );

  if (!sizeGuide) return null;

  if (
    !sizeGuide.instructionIcons ||
    !sizeGuide.brasBandTable ||
    !sizeGuide.brasCupTable
  ) {
    return null;
  }

  return (
    <>
      {showState !== null && (
        <button
          onClick={() => setShowState(null)}
          className="text-body-md mb-4"
        >
          {translate("Size_Guide_Back_Button")}
        </button>
      )}
      {showState === null && (
        <section className="px-6 lg:px-8 pt-6 pb-20 lg:py-10">
          <div className="text-center mb-6 lg:mb-8">
            <div className="uppercase tracking-widest text-[12px] lg:text-sm text-[#6b6b6b]">
              {translate("Size_Guide_Calculator_Bra_Eyebrow")}
            </div>
            <h2 className="font-serif text-[28px] leading-tight lg:text-[40px] mt-2">
              {translate("Size_Guide_Calculator_Bra_Title")}
            </h2>
            <p className="max-w-[720px] mx-auto text-[#383838] mt-3 lg:mt-4">
              {translate("Size_Guide_Calculator_Bra_Description")}
            </p>
            <div className="mt-5 flex justify-center">
              <ButtonAsButton
                ariaLabel={translate("Size_Guide_Calculator_Bra_Button")}
                label={translate("Size_Guide_Calculator_Bra_Button")}
                onClick={() => setShowState("calculator")}
                variants={{ width: "auto", style: "solid" }}
              />
            </div>
          </div>

          <hr className="my-8 border-[#e5e5e5]" />

          <div className="text-center">
            <div className="uppercase tracking-widest text-[12px] lg:text-sm text-[#6b6b6b]">
              {translate("Size_Guide_Table_Bra_Eyebrow")}
            </div>
            <h3 className="font-serif text-[28px] leading-tight lg:text-[36px] mt-2">
              {translate("Size_Guide_Table_Bra_Title")}
            </h3>
            <p className="max-w-[720px] mx-auto text-[#383838] mt-3 lg:mt-4">
              {translate("Size_Guide_Table_Bra_Description")}
            </p>
            <div className="mt-5 flex justify-center">
              <ButtonAsButton
                ariaLabel={translate("Size_Guide_Table_Bra_Button")}
                label={translate("Size_Guide_Table_Bra_Button")}
                onClick={() => setShowState("table")}
                variants={{ width: "auto", style: "outline" }}
              />
            </div>
          </div>
        </section>
      )}
      {showState === "calculator" && (
        <iframe
          src={`https://sizeguide.missmary.com/?chart=${currentCountryCode.toLowerCase()}&lang=${currentLanguageCode}`}
          className="w-full h-screen"
          title={translate("Size_Guide_Calculator_Title")}
        ></iframe>
      )}
      {showState === "table" && (
        <>
          <MeasuringInstructions />
          <SizeGuideTableWrapper
            tableData={sizeGuide.brasBandTable}
            icon={sizeGuide.bandTableIcon}
            title={translate("Size_Guide_Band_Size_Title")}
          />
          <SizeGuideTableWrapper
            tableData={sizeGuide.brasCupTable}
            icon={sizeGuide.cupTableIcon}
            title={translate("Size_Guide_Cup_Size_Title")}
          />
          <SizeGuideFooter />
        </>
      )}
    </>
  );
};
